const routes = [
  {
    path: '/account',
    component: () =>
      import(
        /* webpackChunkName: 'account' */ '@/views/account/AccountMain.vue'
      ),

    children: [
      {
        path: '/account',
        name: 'profile',
        component: () =>
          import(
            /* webpackChunkName: 'profile' */ '@/views/account/Profile.vue'
          )
      }
    ]
  }
]

export default routes
